export default __webpack_public_path__ + "static/IN-9008HD-vs-IN-5905HD_night-ab3b7467011135e7ae06f408ef75b3a4.webp";